import { render, staticRenderFns } from "./Worth.vue?vue&type=template&id=476620da"
import script from "./Worth.vue?vue&type=script&lang=js"
export * from "./Worth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports